<template>
    <v-dialog v-model="dialog" persistent transition="dialog-bottom-transition" @keydown.esc="chiudi()" width="500">
        <v-card>
            <v-toolbar dark color="primary" dense>
                <v-btn icon dark v-on:click="chiudi()">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Zoom</v-toolbar-title>
            </v-toolbar>

            <v-img :src="img"></v-img>

        </v-card>
    </v-dialog>
</template>

<script>


export default {
    props: {
        dialog: { type: Boolean, default: false },
        img: { type: String, default: "" },
    },

    methods: {
        caricaDati() {

        },

        chiudi() {
            this.$emit("chiudiDialog");

        },
    },

    watch: {
        img() {

        },

        dialog(val) {
            return !val || this.caricaDati();
        },
    }

}
</script>